/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { LoadingButton as MButton } from '@mui/lab'
import { ButtonProps, createTheme, ThemeProvider } from '@mui/material'
import block from 'bem-cn'

import './Button.scss'

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    main: true
  }
}

type CustomButtonProps = ButtonProps & {
  text?: string | number
  callback?: (a: any) => void
  disabled?: boolean
  uppercase?: boolean
  link?: string
  variant?: string
  loading?: boolean
  colorType?:
    | 'main'
    | 'secondary'
    | 'secondaryOutlineRed'
    | 'tertiary'
    | 'orange'
    | 'white'
    | 'yellow'
    | 'green'
    | 'login'
    | 'notify'
    | 'gradient'
    | 'gradientlight'
  rounded?: boolean
  height?: string
  icon?: { svg: any }
  [x: string]: any
}

const Button: React.FC<CustomButtonProps> = ({
  text,
  callback,
  variant = 'contained',
  children,
  disabled = false,
  uppercase = false,
  colorType = 'main',
  rounded = false,
  type,
  loading = false,
  link,
  height,
  icon,
  ...props
}) => {
  const b = block('button')
  const history = useHistory()

  const theme = createTheme({
    components: {
      MuiCircularProgress: {
        styleOverrides: {
          root: {
            '& svg *': {
              stroke: '#fff',
            },
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            display: 'flex',
            height,
            width: '100%',
            textAlign: 'center',
            borderRadius: '10px',
            transition: 'all 0.3s ease !important',
            fontSize: '18px !important',
            fontStyle: 'normal !important',
            fontWeight: '700  !important',
          },
        },
      },
    },
  })

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      if (link && !disabled) {
        history.push(link)
      } else if (callback && !disabled) {
        callback(e)
      }
    },
    [history, link, callback, disabled],
  )

  return (
    <div className={b('button-container', { uppercase, disabled, loading, withIcon: !!icon })}>
      <ThemeProvider theme={theme}>
        <MButton
          {...props}
          disableElevation
          type={type}
          loading={loading}
          variant={variant}
          disabled={disabled}
          className={b({ colors: colorType, rounded }, { variant })}
          onClick={e => (disabled ? (d: any) => d : onClick(e))}>
          {icon && <icon.svg className={b('icon-svg')} />}
          {text}
          {children}
        </MButton>
      </ThemeProvider>
    </div>
  )
}

export default Button
